import {defineStore} from "pinia";
import {useICPStore} from "@/stores/icpStore";
import {useAuthStore} from "@/stores/authStores";
import {notifyErrorUpdate, notifyLoading, notifySuccessUpdate} from "@/services/toastService";
import {useCallsStore} from "@/stores/callsStore";
import {useMediaStore} from "@/stores/mediaStore";
import api from '@/services/api'
import {useContactsStore} from "@/stores/contactsStore";

export const useGroupCallsStore = defineStore('groupCalls', {
    state: () => ({
        calls: [],
        selectedCall: [],
        callHistory: [],
        presetGroupsIds: [],
        t2tGroupIsdn: "",
        patchGroupIsdn: "",
        groupsConfigReady: false,
        pttDisabled: true,
        putInCommGreen: false,
        groupUpdateReference: []
    }),


    actions: {


        fetchHistory() {
            api.get('/groupCall/getHistory', {
                params: {
                    user: useAuthStore().loggedUser
                }
            })
                .then(response => {
                    this.callHistory = response.data;
                })
                .catch(error => {
                    console.error("There was an error fetching the call history: ", error);
                });
        },

        pushToHistory(call) {
            useMediaStore().alignShowValue();
            api.post(
                '/groupCall/addToHistory',
                call,
                {headers: {'Content-Type': 'application/json'}}
            )
                .then(() => {
                    this.fetchHistory();
                })
                .catch(error => {
                    console.error("There was an error adding the group call to history: ", error);
                });
        },

        handleGroupAutocreation(isdn, name) {
            switch (name) {
                case "Main Line " + "(" + useAuthStore().loggedUserProfile + ")":
                    this.presetGroupsIds.push(isdn);
                    break;
                case "Depot " + "(" + useAuthStore().loggedUserProfile + ")":
                    this.presetGroupsIds.push(isdn);
                    break;
                case "T2T " + "(" + useAuthStore().loggedUserProfile + ")":
                    this.t2tGroupIsdn = isdn;
                    break;
                case "Dynamic " + "(" + useAuthStore().loggedUserProfile + ")":
                    this.patchGroupIsdn = isdn;
                    break;
            }

            // check if all three groups are set
            if (this.presetGroupsIds.length === 1 && this.t2tGroupIsdn !== "" && this.patchGroupIsdn !== "") {
                // all groups are set, create JSON and to add configuration to the backend
                const groupsConfig = {
                    presetGroups: this.presetGroupsIds,
                    t2tGroup: this.t2tGroupIsdn.toString(),
                    patchGroup: this.patchGroupIsdn.toString()
                };
                console.log("All groups created, saving configuration to the backend: ", groupsConfig);
                api.post('/mcx/addGroupsToOperator', {
                    operatorProfileId: useAuthStore().loggedUserProfile.toString(),
                    groupsConfig: JSON.stringify(groupsConfig)
                }).then(() => {
                    // after saving configuration, initialize groups
                    notifySuccessUpdate("autocreate", "All default groups created successfully, saving configuration and loading groups ...");
                    useGroupCallsStore().fetchGroupsFromSDK();
                }).catch(error => {
                    notifyErrorUpdate("autocreate", "Failed to save groups configuration. Rolling back");
                    const idsToDelete = [...this.presetGroupsIds, this.t2tGroupIsdn, this.patchGroupIsdn];
                    // delete created groups
                    idsToDelete.forEach(id => {
                        useICPStore().ICP.dispatch.group.deleteDynamicGroup({
                            "grpid": id,
                            "callback": function () {
                            }
                        });
                    })
                    console.error("Error saving groups configuration:", error);
                })
            }
        },

        initializeGroups() {
            // get group configuration from backend
            api.get('/mcx/getGroupsConfig', {
                params: {
                    operatorProfile: useAuthStore().loggedUser.toString()
                }
            })
                .then(response => {
                    if (response.data !== "") {
                        this.presetGroupsIds = response.data.presetGroups;
                        this.t2tGroupIsdn = response.data.t2tGroup;
                        this.patchGroupIsdn = response.data.patchGroup;
                        this.groupsConfigReady = true;
                        this.fetchGroupsFromSDK();
                    } else {
                        notifyLoading("autocreate", "No group configuration found, creating default groups ...");
                        // create groups
                        const loggedProfile = useAuthStore().loggedUserProfile;
                        var groupNames = []
                        if (loggedProfile.toLowerCase().includes("depot")) {
                            groupNames = ["Depot " + "(" + loggedProfile + ")", "T2T " + "(" + loggedProfile + ")", "Dynamic " + "(" + loggedProfile + ")"];
                        } else {
                            groupNames = ["Main Line " + "(" + loggedProfile + ")", "T2T " + "(" + loggedProfile + ")", "Dynamic " + "(" + loggedProfile + ")"];
                        }
                        // cycle through groupNames and create groups with ICP
                        groupNames.forEach(name => {
                            useICPStore().ICP.dispatch.group.addDynamicGroup({
                                "alias": name,
                                "grpid": "0",
                                "grouplist": [],
                                "maxperiod": "60",
                                "mcxability": "1",
                                "priority": "15",
                                "uelist": [
                                    {
                                        "isdn": useAuthStore().loggedUser.toString()
                                    }
                                ],
                                "callback": function () {
                                }
                            })
                        })

                    }
                })
                .catch(error => {
                    console.error("Error fetching groups configuration:", error);
                });
        },

        fetchGroupsFromSDK() {
            if (this.calls.length === 0) {  // Without this check, duplications may occur when remounting the component
                useICPStore().ICP.dispatch.query.queryTalkingGroupV1({
                    "offset": "0",
                    "limit": "100",
                    "callback": function (data) {
                        if (data.rsp === "0" && data.list) { //TODO: try confronting group id with the presets groups before adding
                            data.list.forEach(group => {
                                // useICPStore().ICP.dispatch.query.queryTalkingGroupMembersV1({
                                //     "grpid": group.group,
                                //     "offset": "0",
                                //     "limit": "100",
                                //     "callback": function (data) {
                                //         data.list.forEach(member => {
                                //             if (member.isdn === useAuthStore().loggedUser) {
                                //                 useGroupCallsStore().addGroup(group);
                                //             }
                                //         });
                                //     }
                                // });
                                if (group.group === useGroupCallsStore().t2tGroupIsdn || group.group === useGroupCallsStore().patchGroupIsdn || useGroupCallsStore().presetGroupsIds.includes(group.group)) {
                                    useGroupCallsStore().addGroup(group);
                                } else {
                                    useICPStore().ICP.dispatch.query.queryTalkingGroupMembersV1({
                                        "grpid": group.group,
                                        "offset": "0",
                                        "limit": "100",
                                        "callback": function (data) {
                                            data.list.forEach(member => {
                                                const loggedProfile = useAuthStore().loggedUserProfile;
                                                const groupNames = ["Depot " + "(" + loggedProfile + ")", "T2T " + "(" + loggedProfile + ")", "Dynamic " + "(" + loggedProfile + ")", "Main Line " + "(" + loggedProfile + ")"];
                                                if (member.isdn === useAuthStore().loggedUser && !groupNames.includes(group.name)) {
                                                    useGroupCallsStore().addGroup(group);
                                                }
                                            });
                                        }
                                    });
                                }
                            });
                            useGroupCallsStore().groupsConfigReady = true;
                        } else {
                            console.error("Failed to fetch group calls:", data);
                        }
                    }
                });
            }
        },

        addGroup(group) {
            const index = this.calls.findIndex(c => c.isdn === group.group);
            if (index === -1) { // not already in the list
                useICPStore().ICP.dispatch.group.subscribeTalkingGroup({
                    "grpid": group.group,
                    "callback": function () {
                        const newGroup = {
                            isdn: group.group,
                            groupId: group.name,
                            status: "-",
                            operator: "-",
                            time: "-",
                            emergency: false,
                            volume: 75
                        };
                        useGroupCallsStore().calls.push(newGroup);
                    }
                })
            }
        },

        removeGroup(grpid) {
            const index = this.calls.findIndex(c => c.isdn === grpid);
            if (index !== -1) {
                useICPStore().ICP.dispatch.group.unsubscribeTalkingGroup({
                    "grpid": grpid,
                    "callback": function () {
                    }
                });
                this.calls.splice(index, 1);
            }
        },

        updateCallStatus(data) {
            const index = this.calls.findIndex(c => c.isdn === data.value.grpid);
            if (index !== -1) {
                if (data.eventName === "OnTalkingGroupCallPTTIdle") {
                    this.calls[index].status = 'Idle';
                    this.calls[index].operator = "-";
                }
                if (data.eventName === "OnTalkingGroupCallPTTNotify") {
                    this.calls[index].status = 'Transmitting';
                    //this.calls[index].operator = data.value.name + " (" + data.value.speaker + ")";
                    const speaker = data.value.speaker;
                    const trainId = this.fetchTrainId(speaker);

                    this.calls[index].operator =
                        speaker === useAuthStore().loggedUser
                            ? useAuthStore().loggedUserProfile + " (" + speaker + ")"
                            : trainId !== speaker
                                ? trainId + " (" + speaker + ")"
                                : data.value.name + " (" + speaker + ")";
                }

                if (data.eventName === "OnTalkingGroupEmergencyCallUp") {
                    this.calls[index].emergency = true;
                    this.calls[index].status = 'Transmitting';
                    //this.calls[index].operator = data.value.name + " (" + data.value.speaker + ")";
                    const speaker = data.value.speaker;
                    const trainId = this.fetchTrainId(speaker);

                    this.calls[index].operator =
                        speaker === useAuthStore().loggedUser
                            ? useAuthStore().loggedUserProfile + " (" + speaker + ")"
                            : trainId !== speaker
                                ? trainId + " (" + speaker + ")"
                                : data.value.name + " (" + speaker + ")";
                }

                // unmute call if it is selected
                if (this.selectedCall.some(item => item === data.value.grpid)) {
                    this.unmuteCall(data.value.cid, this.calls[index].isdn);
                } else {
                    this.muteCall(data.value.cid);
                }
            }
        },

        fetchTrainId(speakerIsdn) {
            const map = useContactsStore().allTrainNumbersCached;
            return map[speakerIsdn] || speakerIsdn;
        },

        startCall(data) {
            const index = this.calls.findIndex(c => c.isdn === data.value.grpid);
            if (index !== -1) {
                this.calls[index].time = Date.now();
                this.calls[index].callid = data.value.cid;
                this.calls[index].initiator = data.value.speaker;
            }
            // if the call is not in the selectedCall array, mute it
            if (!this.selectedCall.some(item => item === data.value.grpid)) {
                this.muteCall(data.value.cid);
            } else {
                this.unmuteCall(data.value.cid, this.calls[index].isdn);
            }
        },

        muteCall(cid) {
            useICPStore().ICP.dispatch.device.setVolume({
                "cid": cid,
                "volume": "0",
                "callback": function () {
                }
            })

            useICPStore().ICP.dispatch.device.muteMic({
                "cid": cid,
                "callback": function () {
                }
            })
        },

        unmuteCall(cid, isdn) {
            useICPStore().ICP.dispatch.device.setVolume({
                "cid": cid,
                "volume": this.getGroupByIsdn(isdn).volume.toString(),
                "callback": function () {
                }
            })
            useICPStore().ICP.dispatch.device.unmuteMic({
                "cid": cid,
                "callback": function () {
                }
            })
        },

        setGroupVolume(newVolume) {
            this.getGroupByIsdn(this.getActiveGroupIsdn).volume = newVolume;
            if (this.getGroupByIsdn(this.getActiveGroupIsdn).callid) {
                useICPStore().ICP.dispatch.device.setVolume({
                    "cid": this.getGroupByIsdn(this.getActiveGroupIsdn).callid,
                    "volume": newVolume.toString(),
                    "callback": function () {
                    }
                })
            }
        },

        endCall(data) {
            const index = this.calls.findIndex(c => c.isdn === data.value.grpid);
            if (index !== -1) {
                var groupCallRecord = {
                    groupId: this.calls[index].groupId,
                    operator: this.calls[index].initiator,
                    time: this.calls[index].time,
                    type: this.calls[index].emergency ? "Emergency" : "Normal",
                    callid: this.calls[index].callid,
                }
                // reset call properties
                this.pushToHistory(groupCallRecord);
                this.resetCall(data.value.grpid)
                this.setSelectedCall([]);
            } else {
                console.error(`Group call with ID ${data.value.grpid} not found.`);
            }
        },

        resetCall(grpid) {
            const index = this.calls.findIndex(c => c.isdn === grpid);
            if (index !== -1) {
                this.calls[index].status = '-';
                this.calls[index].operator = "-";
                this.calls[index].time = "-";
                this.calls[index].callid = null;
                this.calls[index].emergency = false;
                // if (grpid === this.t2tGroupIsdn || grpid === this.patchGroupIsdn) {
                //     this.putInCommGreen = false;
                //     this.emptyGroup(grpid);
                // }
                //emptying all groups
                this.putInCommGreen = false;
                this.emptyGroup(grpid);
            } else {
                console.error(`Group call with ID ${grpid} not found.`);
            }

        },

        reactToGroupChange(data) {
            if (((data.opt === "modify" || "create") && data.groupinfo.isdn === useAuthStore().loggedUser) || data.opt === "delete") {
                const targetGroupId = data.groupinfo.group;
                useICPStore().ICP.dispatch.query.queryTalkingGroupMembersV1({
                    "grpid": targetGroupId,
                    "offset": "0",
                    "limit": "100",
                    "callback": function (data) {
                        var imMember = false;
                        data.list?.forEach(member => {
                            if (member.isdn === useAuthStore().loggedUser) {
                                imMember = true;
                            }
                        })
                        var groupSubscribed = false;
                        useGroupCallsStore().calls?.forEach(group => {
                            if (group.isdn === targetGroupId) {
                                groupSubscribed = true;
                            }
                        })
                        if (imMember && !groupSubscribed) {
                            // query group information and add user to group
                            useICPStore().ICP.dispatch.query.queryTalkingGroupV1({
                                "offset": "0",
                                "limit": "100",
                                "callback": function (data) {
                                    if (data.rsp === "0") {
                                        var added = false;
                                        data.list.forEach(group => {
                                            if (group.group === targetGroupId && !added) {
                                                useGroupCallsStore().addGroup({
                                                    group: group.group,
                                                    name: group.name
                                                });
                                                added = true;
                                            }
                                        });
                                    } else {
                                        console.error("Failed to fetch group calls:", data);
                                    }
                                }
                            })

                        } else if (!imMember && groupSubscribed) {
                            useGroupCallsStore().removeGroup(targetGroupId)
                        }
                    }
                })
            }
        },

        realignSelectedCallsVolume() {
            this.calls?.forEach(group => {
                if (group.callid) {
                    if (this.selectedCall.some((s) => s === group.isdn)) {
                        this.unmuteCall(group.callid, group.isdn);
                    } else {
                        this.muteCall(group.callid);
                    }
                }
            })
        },

        realignT2TGroup(members) {
            this.groupUpdateReference = members;
            this.pttDisabled = true;
            this.putInCommGreen = false;
            this.realignDynamicGroupMembers(this.t2tGroupIsdn, members);
        },

        realignPatchGroup(members) {
            this.groupUpdateReference = members;
            this.pttDisabled = true;
            this.putInCommGreen = false;
            this.realignDynamicGroupMembers(this.patchGroupIsdn, members);
        },

        realignPresetGroup(grpId) {
            this.pttDisabled = true;
            const group = this.getGroupByIsdn(grpId);
            const groupName = group.groupId || grpId;
            notifyLoading(grpId, "Fetching new " + groupName + " members ...");
            api.get('/train/getOnlineTrains', {
                params: {
                    loggedUsername: useAuthStore().loggedUser
                }
            })
                .then(response => {
                    const members = response.data.map(train => train.isdn);
                    this.groupUpdateReference = members;
                    this.realignDynamicGroupMembers(grpId, members);
                })
                .catch(error => {
                    console.error("Error fetching " + groupName + " members: ", error);
                    notifyErrorUpdate(grpId, "Failed to fetch " + groupName + " updated members.");
                });
        },

        realignDynamicGroupMembers(grpId, members) {
            const group = this.getGroupByIsdn(grpId);
            const groupName = group.groupId || grpId;
            notifyLoading(grpId, "Updating " + groupName + " members ...");
            useICPStore().ICP.dispatch.query.queryTalkingGroupMembersV1({
                "grpid": grpId,
                "offset": "0",
                "limit": "100",
                "callback": (data) => {
                    if (data.rsp === "0") {
                        // create remove list that looks like this: [{isdn: "666001"}, {isdn: "777000"}] from data.list if isdn is not in depotGroupMembers or if the user refers to the logged in
                        var membersToRemove = data.list
                            .filter(member => !members.includes(member.isdn))
                            .filter(member => member.isdn !== useAuthStore().loggedUser)
                            .map(member => ({isdn: member.isdn}));
                        // vice versa
                        var membersToAdd = members
                            .filter(member => !data.list.some(existingMember => existingMember.isdn === member))
                            .map(isdn => ({isdn: isdn}));

                        if (membersToRemove.length > 0 || membersToAdd.length > 0) {
                            useICPStore().ICP.dispatch.group.modifyDynamicGroup({
                                "grpid": grpId,
                                "addlist": membersToAdd,
                                "dellist": membersToRemove,
                                "callback": (data) => {
                                    if (data.rsp !== "0") {
                                        notifyErrorUpdate(grpId, "Failed to update " + groupName + " members.");
                                        this.pttDisabled = true;
                                    }
                                }
                            });
                        } else {
                            // no waiting time in here: all members are already aligned
                            notifySuccessUpdate(grpId, groupName + " members successfully updated!");
                            if (grpId === this.t2tGroupIsdn || grpId === this.patchGroupIsdn) {
                                this.setSelectedCall([grpId])
                                this.putInCommGreen = true;
                            }
                            this.pttDisabled = false;
                        }

                    } else {
                        notifyErrorUpdate(grpId, "Failed to fetch current " + groupName + " members.");
                        this.pttDisabled = true;
                    }
                }
            })
        },

        emptyGroup(grpId) {
            const group = this.getGroupByIsdn(grpId);
            const groupName = group.groupId || grpId;
            notifyLoading(grpId, groupName + " No longer needed, emptying members ...");
            const newSelected = this.selectedCall.filter(item => item !== grpId);
            this.setSelectedCall(newSelected);
            useICPStore().ICP.dispatch.query.queryTalkingGroupMembersV1({
                "grpid": grpId,
                "offset": "0",
                "limit": "100",
                "callback": (data) => {
                    if (data.rsp === "0") {
                        var membersToRemove = data.list
                            .filter(member => member.isdn !== useAuthStore().loggedUser)
                            .map(member => ({isdn: member.isdn}));
                        if (membersToRemove.length !== 0) {
                            useICPStore().ICP.dispatch.group.modifyDynamicGroup({
                                "grpid": grpId,
                                "addlist": [],
                                "dellist": membersToRemove,
                                "callback": (data) => {
                                    if (data.rsp !== "0") {
                                        notifyErrorUpdate(grpId, "Failed to empty " + groupName + " members.");
                                    }
                                }
                            });
                        }
                    } else {
                        notifyErrorUpdate(grpId, "Failed to empty " + groupName + " members.");
                    }
                }
            })
        },

        handleDynamicRealignFailure(grpId) {
            const group = this.getGroupByIsdn(grpId);
            const groupName = group.groupId || grpId;
            if (grpId === this.t2tGroupIsdn || grpId === this.patchGroupIsdn) {
                // handle T2T group realignment
                notifyErrorUpdate(grpId, "Failed to update " + groupName + " members.");
                this.pttDisabled = true;
                this.putInCommGreen = false;
            } else if (this.presetGroupsIds.includes(grpId)) {
                // handle preset group realignment
                notifyErrorUpdate(grpId, "Failed to update " + groupName + " members.");
                this.pttDisabled = true;
            }
        },

        handleDynamicRealignSuccess(data) {
            const grpId = data.groupinfo.group;
            const groupName = this.getGroupByIsdn(grpId).groupId || grpId;
            const loggedInUser = useAuthStore().loggedUser
            var currentMemebers = [];
            useICPStore().ICP.dispatch.query.queryTalkingGroupMembersV1({
                "grpid": grpId,
                "offset": "0",
                "limit": "100",
                "callback": (data) => {
                    if (data.rsp === "0") {
                        // load current members as an array of isdn
                        currentMemebers = data.list
                            .filter(member => member.isdn !== loggedInUser)
                            .map(member => member.isdn);
                        if (currentMemebers.length === 0) {
                            // notify group empty
                            notifySuccessUpdate(grpId, groupName + " members emptied successfully.");
                        } else if ((currentMemebers.sort()).toString() === (this.groupUpdateReference.sort()).toString()) {// order the arrays in ascending order then turn them into strings to compare{
                            // notify group updated successfully
                            // wait 10 seconds to allow devices to subscribe to the group
                            console.log("Waiting 10 seconds for devices to subscribe to the group ...");
                            setTimeout(() => {
                                notifySuccessUpdate(grpId, groupName + " members updated successfully.");
                                this.setSelectedCall([grpId]);
                                this.pttDisabled = false;
                                if (grpId === this.t2tGroupIsdn || grpId === this.patchGroupIsdn) {
                                    this.putInCommGreen = true;
                                }
                            }, 10000);
                        }
                    }
                }
            })
        },

        setSelectedCall(selectedKeys) {
            const oldSelect = this.selectedCall
            this.selectedCall = selectedKeys;
            useMediaStore().alignShowValue();
            if (selectedKeys.length > 0) {
                useCallsStore().setSelectedCall(null);
            }
            if (selectedKeys.length === 1) {
                this.pttDisabled = false;
            } else {
                this.pttDisabled = true;
            }
            // scroll selected keys to see if are in the list of present groups ids
            selectedKeys.forEach(key => {
                if (this.presetGroupsIds.includes(key)) {
                    this.realignPresetGroup(key);
                }
            });
            // check if pttGroup was selected and it's not anymore
            if (this.putInCommGreen === true && oldSelect.length > 0 && oldSelect.includes(this.t2tGroupIsdn) && !selectedKeys.includes(this.t2tGroupIsdn)) {
                // run group emptying for T2T
                this.emptyGroup(this.t2tGroupIsdn);
                this.putInCommGreen = false
            }

            // check if patchGroup was selected and it's not anymore
            if (this.putInCommGreen === true && oldSelect.length > 0 && oldSelect.includes(this.patchGroupIsdn) && !selectedKeys.includes(this.patchGroupIsdn)) {
                // run group emptying for T2T
                this.emptyGroup(this.patchGroupIsdn);
                this.putInCommGreen = false
            }
            this.realignSelectedCallsVolume();
        }
    },

    getters: {
        getGroupByIsdn: state => (isdn) => {
            return state.calls.find(group => group.isdn === isdn) || {};
        },

        getIsdnArray: state => {
            var array = [];
            state.selectedCall.forEach(item => {
                array.push({isdn: item});
            });
            return array;
        },

        getActiveGroupIsdn: state => {
            if (state.selectedCall.length === 1) {
                return state.selectedCall[0];
            } else if (state.selectedCall.length > 1) {
                return state.patchGroupIsdn;
            }
        },

        history: state => {
            // Sort the call history by endTime in descending order
            return state.callHistory.sort((a, b) => {
                return b.time - a.time;
            });
        },
    }
})